import { getHeroData } from '@/modules/program-page'
import React, { ComponentPropsWithoutRef } from 'react'
import { Badge } from '~shared/components/badge'
import { Button } from '~shared/components/button-v2'
import { LeadFormDialog } from '~widgets/lead-form/components/lead-form-dialog'

export interface IntroSectionProps {
  hero: Awaited<Promise<ReturnType<typeof getHeroData>>>
}

export const IntroSection: React.FC<IntroSectionProps> = ({ hero }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <section className='container container-slim '>
      <div className='bg-[#F2F2F2]  rounded-[64px] p-[60px] relative z-[10]'>
        <img
          src='/assets/imgs/psychology-course-page/stripe_cut.png'
          alt='stripe'
          className='h-[calc(100%-60px)] absolute top-[60px] right-0 z-[5]'
        />
        <div className='flex justify-between text-[#1D1D1D] z-[10] relative'>
          <div className='flex'>
            <Badge className='bg-[#9D9D9D] text-white'>
              Программа 2024 года
            </Badge>
            <Badge className='bg-white'>{hero?.category.label}</Badge>
          </div>
          <Badge className='bg-[#FFF741]'>
            скидка {hero?.cost.discount}% до {hero?.cost.discountUntil}
          </Badge>
        </div>
        <div className='grid grid-cols-2 mt-[40px]'>
          <div className='max-w-[570px] 2xl:max-w-[670px] flex flex-col gap-[40px]'>
            <div>
              <h1 className='m-0 text-[64px]/[80%] font-medium'>
                {hero?.name}
              </h1>
              <p className='text-[#8B8B8B] mt-[24px]'>
                Станьте консультирующим психологом с дипломом государственного
                образца за 6 месяцев. Получите востребованную профессию и
                начните вести собственную практику.
              </p>
            </div>
            <ul className='list-disc flex flex-col gap-[16px]'>
              <li className='list-disc list-inside'>
                Ближайшее зачисление 20 ноября
              </li>
              <li className='list-disc list-inside'>
                Срок обучения 12 месяцев
              </li>
              <li className='list-disc list-inside'>
                Дистанционный формат обучения
              </li>
              <li className='list-disc list-inside'>
                Диплом о проф. переподготовке по окончанию обучения
              </li>
              <li className='list-disc list-inside'>
                Длительность программы 1500 часов
              </li>
            </ul>
            <div className='flex items-center gap-[16px]'>
              <Button
                size='slg'
                variant='secondary'
                onClick={() => setIsOpen(true)}
                className='px-[80px] w-fit 2xl:h-[100px] 2xl:text-[24px]'>
                Записаться на обучений
              </Button>

              <div>
                <p className='text-[24px]/[80%] text-accent font-medium'>
                  от 9 170 ₽/мес.
                </p>
                <p className='text-[12px]/[80%] my-[8px] text-[#3A52EE80]'>
                  рассрочка на 12 месяцев*
                </p>
                <p className='text-[14px]'>от 12 170 ₽/мес.</p>
              </div>
            </div>
          </div>
          <div className='h-[300px] w-[300px] relative z-10 justify-self-center  2xl:ml-[80px] mt-[40px]'>
            <img
              src={hero?.image.url ?? ''}
              alt='stripe'
              className=' h-full rounded-[40px]'
            />
            <img
              src='/assets/imgs/psychology-course-page/heart.png'
              alt='stripe'
              className='h-[200px] absolute right-[-150px] bottom-[-80px]'
            />
          </div>
        </div>
      </div>
      <LeadFormDialog open={isOpen} onOpenChange={setIsOpen} />
    </section>
  )
}
